import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-class-students',
  templateUrl: './class-students.component.html',
  styleUrls: ['./class-students.component.scss']
})
export class ClassStudentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
